var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fieldset',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('v-card',{staticClass:"mx-auto",attrs:{"max-width":"500","outlined":""}},[_c('v-card-text',[_c('v-container',{staticClass:"py-0"},[_c('v-row',[_c('span',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.branchInfoName)+" ")])])],1)],1)],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }